import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Components
import { ExclamationTriangle } from '../../../../Svg'
import { Text, Button, Popup } from '../../../..'

// Hooks
import { useListingDisplay } from '../../../../../hooks/listing'

// styles
import styles from './Standard.module.scss'

const Standard = ({ onClose }) => {
  const [loading, setLoading] = useState(false)
  const { refetch: refetchAllQueries } = useListingDisplay()

  const handleRetryClick = () => {
    setLoading(true)
    refetchAllQueries()
    setTimeout(() => {
      setLoading(false)
    }, 2000)
  }

  return (
    <Popup onClose={onClose}>
      <ExclamationTriangle className={styles.triangle} />
      <Text color='white' weight='bold' size='l'>
        Something went wrong
      </Text>
      <Text color='heather'>Let's see if we can try again</Text>
      <Button
        regular
        wide
        className={styles.retryButton}
        loading={loading}
        onClick={handleRetryClick}
      >
        Retry
      </Button>
      <hr />
      <Text color='heather' className={styles.reachOut}>
        If the problem continues,
      </Text>
      <Text color='heather'>
        reach out to
        <a href={'mailto:support@homebot.ai'} className={styles.link}>
          {' '}
          support@homebot.ai
        </a>
      </Text>
    </Popup>
  )
}

Standard.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default Standard
